import React, { Component } from 'react';
import ReactSelect from '../../components/ReactSelect';

class AdditionalBox extends Component {
    constructor() {
        super();
    }

    render() {
        const { t } = this.props;
        const options = [
            { label: 'All', value: '' },
            { label: 'PERSON', value: 'PERSON' },
            { label: 'ORGANIZATION', value: 'ORGANIZATION' },
            { label: 'EVENT', value: 'EVENT' },
            { label: 'CONSUMER_GOOD', value: 'CONSUMER_GOOD' },
            { label: 'WORK_OF_ART', value: 'WORK_OF_ART' },
            { label: 'ADDRESS', value: 'ADDRESS' },
            { label: 'FACILITY', value: 'FACILITY' },
            { label: 'GEOGRAPHICFEATURE', value: 'GEOGRAPHICFEATURE' },
            { label: 'JOBTITLE', value: 'JOBTITLE' },
            { label: 'LOCATION', value: 'LOCATION' },
            { label: 'OTHER', value: 'OTHER' },
        ];
        return (
            <>
                <div className="table-additional-view">
                    <ReactSelect
                        options={options}
                        isSearchable={false}
                        value={options.find((item) => item.value === this.props.selectedType)}
                        placeholder="Type"
                        onChange={(value) => this.props.handleTypeChange(value)}
                        blurInputOnSelect={true}
                        classname="mr-10"
                    />
                    <div className="toggle-Invalid-items mt-0">
                        <span
                            className={`switch-button without-text mr-10 ${
                                this.props.toggleWiki ? 'active' : 'not-active'
                            }`}
                            onClick={() => this.props.onToggleWiki()}
                        >
                            <span className="switch-circle" />
                        </span>
                        <span>{t('discover.entities.table.wiki_message')}</span>
                    </div>
                </div>
            </>
        );
    }
}

export default AdditionalBox;
